import queryString from 'query-string';
import fixtures from './fixtures';
import HttpStatus from 'http-status-codes';

function createError(status) {
  return {
    response: {
      status
    }
  };
}

function createResult(data) {
  return {
    result: data
  };
}

function createApi() {
  return {
    loginWithEmail: async ({ email, password }) => {
      const { user } = fixtures;
      if (user.email === email && user.password === password) {
        return createResult({
          authToken: 'test',
          refreshToken: 'test'
        });
      }
    },
    registerWithEmail: async () => {
      return createResult({
        authToken: 'test',
        refreshToken: 'test'
      });
    },
    getAuthToken: async ({ refreshToken }) => {
      return createResult(refreshToken);
    },
    fetchClients: async () => {
      const {
        clients: { members, pagination }
      } = fixtures;
      let clientsList = [];
      for (let i = 1; i <= 1000; i++) {
        clientsList.push({
          ...members,
          propertyName:
            Math.random()
              .toString(36)
              .substr(2, 10) +
            ' - ' +
            i
        });
      }
      return createResult({ members: clientsList, pagination });
    },
    fetchCoupons: async params => {
      const { limit } = queryString.parse(params);
      const { coupons } = fixtures;
      let couponsList = [];
      for (let i = 1; i <= 100; i++) {
        couponsList.push({
          ...coupons,
          title: i,
          discount:
            Math.random()
              .toString(36)
              .substr(2, 6) +
            ' - ' +
            i +
            ' %'
        });
      }
      limit && couponsList.splice(limit);
      return createResult(couponsList);
    },
    createCoupon: async ({
      discount,
      discountType,
      status,
      usagePerUser,
      usageTotal,
      title,
      notes,
      property,
      serviceType,
      aliases
    }) => {
      return createResult({
        discount: discount + ' ' + discountType,
        active: status === 'active',
        usagePerUser,
        usageTotal,
        notes,
        propertyID: property.toString(),
        serviceID: serviceType.toString(),
        recurrences: 2,
        userID: 40,
        title,
        aliases: aliases.map((alias, i) => ({ name: alias, used: i + 1 })),
        createdAt: new Date().toISOString(),
        expiry: '2019-08-29T16:56:05.959Z'
      });
    },
    fetchRequests: async () => {
      const {
        requests: { list, pagination }
      } = fixtures;
      let requestsList = [];
      for (let i = 1; i <= 136; i++) {
        requestsList.push({
          ...list,
          unitNumber: i
        });
      }
      return createResult({ list: requestsList, pagination });
    },
    fetchProperties: async () => {
      const {
        properties: { properties, pagination }
      } = fixtures;
      let propertiesList = [];
      for (let i = 1; i <= 1000; i++) {
        let buildingsNames = i >= 10 ? [] : properties.buildingsNames;
        let bedroomsCounts = i >= 20 ? [] : properties.bedroomsCounts;
        propertiesList.push({
          ...properties,
          buildingsNames,
          bedroomsCounts,
          address:
            Math.random()
              .toString(36)
              .substr(2, 10) +
            ' - ' +
            i
        });
      }
      return createResult({ properties: propertiesList, pagination });
    },
    fetchUsers: async () => {
      const {
        users: { users, pagination }
      } = fixtures;
      let usersList = [];
      for (let i = 1; i <= 136; i++) {
        usersList.push({
          ...users,
          phone:
            Math.random()
              .toString(36)
              .substr(2, 10) +
            ' - ' +
            i
        });
      }
      return createResult({ users: usersList, pagination });
    },
    checkUserEmailAvailability: async email => {
      const { user } = fixtures;
      if (email === user.email) {
        throw createError(HttpStatus.BAD_REQUEST);
      } else {
        return createResult(true);
      }
    },
    createUser: async ({ role, phone, lastName, firstName, email }) => {
      return createResult({
        createdAt: new Date().toISOString(),
        role,
        phone,
        lastName,
        firstName,
        email,
        dataSource: null,
        facebookID: null,
        googleID: null,
        isSocial: null,
        lastLoggedAt: '2019-09-11T20:44:46.919Z',
        regionID: null,
        resetPasswordHash: null,
        resetPasswordHashExpiry: null,
        status: 'active',
        userID: 9
      });
    }
  };
}

const apiClient = createApi();

export default apiClient;
